import React from "react";
import './Main.css';

const Content2 = () => {

    return(

    <div>
        <div className="content2">
            <h3>Ustanova za obrazovanje odraslih ,,Centar za obrazovanje odraslih“ Bijeljina</h3>
            <p><span style={{fontWeight: 'bold'}}>Sjedište: </span>Svetog Save 26. (nekadašnja zgrada Učiteljskog fakulteta) </p>
            <p><span style={{fontWeight: 'bold'}}>Broj računa: </span>554-001-00004346-41</p>
            <p><span style={{fontWeight: 'bold'}}>Poreski broj: </span>4403358200003</p>
            <p><span style={{fontWeight: 'bold'}}>Radno vrjeme: </span>10:00h-20:00h</p>
            <p><span style={{fontWeight: 'bold'}}>Slogan: </span>USMJERI I ISKORISTI SVOJE ZNANJE.</p>
            <p><span style={{fontWeight: 'bold'}}>Kontakt: </span><br />055/423-994 Bijeljina<br />
            055/206-342 Bijeljina <br /> 065/874-695 Bijeljina <br />065/547-589 Bijeljina 
            <br /> 066/212-520 Brčko <br />062/346-406 Tuzla <br /> 065/651-412 Derventa i Banja Luka</p>
        </div>
    </div>

    );


}

export default Content2;